stemmer = require('porter-stemmer').stemmer

FragmentHighlighter =
  stemmedKeywords: []

  phrasedKewyords: []

  stopwords:       ['the', 'and', 'but', 'for', 'mid', 'off', 'out', 'per', 'pro', 'qua', 'via', 'an', 'as', 'at', 'by', 'in', 'of', 'on', 'or', 'to', 'up', 'a']

  highlight: ({keywords, selector}) ->
    if keywords?.length
      @setKeywords keywords
      selector ?= '.resource-description, .narrow-search li a'
      $(selector).each (i, el) =>
        $(el).html(@highlightWords(@highlightPhrases($(el).html())))

  setKeywords: (keywords) ->
    phrase_match = keywords.match(/".*?"/)
    if phrase_match?
      @phrasedKewyords = $.map phrase_match, (phrase) =>
        keywords = keywords.replace phrase, ''
        @regexp_escape phrase.replace(/"/g, '')

    @stemmedKeywords = $.map keywords.split(' '), (word) =>
      if word is '' or word.match(/^\s+$/)
        null
      else
        stemmer @stripPunctuation(word)

    # If all words are stopwords we won't highlight anything unless we convert it to a phrase search
    if @allWordsAreStopwords(@stemmedKeywords)
      @phrasedKewyords.push @stemmedKeywords.join(' ') if @stemmedKeywords.length
      @stemmedKeywords.length = 0

  stripPunctuation: (word) ->
    # Only punctuation that would come at the end of a sentence or as part of a contraction
    word.replace /[\.,!?'’";:=`()]/g, ''

  stripTags: (word) ->
    word.replace /(<([^>]+)>)/g, ''

  regexp_escape: (str) ->
    str.replace /[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'

  highlightPhrases: (str) ->
    if @phrasedKewyords.length is 0
      str
    else
      str.replace new RegExp('\\b(' + @phrasedKewyords.join('|') + ')\\b', 'gi'), '<strong>$&</strong>'

  highlightWords: (str) ->
    return str if @stemmedKeywords.length is 0
    str = str.replace /&nbsp;/g, ' '
    words = str.split ' '
    # stopwords are only highlighted when a non-stopword comes after them.
    # To accomplish this, we don't highlight a stopword immediately, but rather keep an array of stopword
    # indices we come across and then look back through that array when we come to a regular keyword.
    stopwords = []
    $.each words, (i, word) =>
      if @wordMatchesKeyword(word)
        stopwords.length = 0 if stopwords[0] + 1 isnt i
        if @wordIsStopword(word)
          stopwords.unshift i
        else
          words[i] = @highlightWord word
          if stopwords[0] + 1 is i
            $.each stopwords, (j, stopword_index) =>
              words[stopword_index] = @highlightWord words[stopword_index]
            stopwords.length = 0


    # Flatten and return highlighted str
    Array.prototype.concat.apply([], words).join ' '

  wordMatchesKeyword: (word) ->
    $.inArray(stemmer(@stripPunctuation(@stripTags(word.toLowerCase()))), @stemmedKeywords) isnt -1

  wordIsHighlighted: (word) ->
    Array.isArray word

  wordIsStopword: (word) ->
    $.inArray(word, @stopwords) isnt -1

  allWordsAreStopwords: (words) ->
    $.grep(words, (word) => !@wordIsStopword(word)).length is 0

  highlightWord: (word) ->
    ['<strong>', word, '</strong>']

LP.module('Searches').FragmentHighlighter = FragmentHighlighter
